// extracted by mini-css-extract-plugin
export var box = "_3i-0";
export var check = "_3i-1";
export var checkboxButton = "_3i-6";
export var checkboxGroup = "_3i-5";
export var disabled = "_3i-7";
export var ghost = "_3i-9";
export var input = "_3i-2";
export var label = "_3i-4";
export var normal = "_3i-8";
export var uncheck = "_3i-3";